import { RotateCcw, Trash2, X } from 'lucide-react'
import { formatDate } from '../lib/project'
import type { ProjectRow } from '../types'

type Props = {
  projects: ProjectRow[]
  busy: boolean
  onClose: () => void
  onRestore: (project: ProjectRow) => void
}

export function TrashDrawer({ projects, busy, onClose, onRestore }: Props) {
  return <div className="drawer-backdrop trash-backdrop" role="presentation" onMouseDown={onClose}>
    <aside className="trash-drawer" role="dialog" aria-modal="true" aria-labelledby="trash-title" onMouseDown={(event) => event.stopPropagation()}>
      <header><div><span className="eyebrow">CORBEILLE</span><h2 id="trash-title">Projets mis de côté</h2></div><button className="icon-button" onClick={onClose} aria-label="Fermer" type="button"><X size={19} /></button></header>
      {projects.length ? <div className="trash-list">{projects.map((project) => <article key={project.id}>
        <Trash2 size={20} />
        <div><strong>{project.name}</strong><span>{project.code} · mis de côté le {formatDate(project.deleted_at ?? undefined)}</span></div>
        <button className="secondary-button" disabled={busy} onClick={() => onRestore(project)} type="button"><RotateCcw size={16} /> Restaurer</button>
      </article>)}</div> : <div className="reminder-empty"><Trash2 size={23} /><strong>La corbeille est vide</strong></div>}
    </aside>
  </div>
}
